if (!customElements.get('ia-load-more')) {
  class IALoadMore extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-load-more-btn]')
      this.grid = document.querySelector(this.dataset.grid)
      if (!this.btn || !this.grid) return

      // Mobile-only "reveal in batches" mode: server returns the desktop
      // page size; on mobile we hide everything past the batch and drip-feed
      // them on click before fetching the next page.
      const batchAttr = parseInt(this.dataset.mobileBatch || '0', 10)
      this.batch = window.innerWidth < 1024 && batchAttr > 0 ? batchAttr : 0
      this.shown = 0

      if (this.batch > 0) {
        const items = this.items()
        items.forEach((item, i) => { item.hidden = i >= this.batch })
        this.shown = Math.min(this.batch, items.length)
      }

      this.btn.addEventListener('click', () => this.handleClick())
    }

    items() {
      return Array.from(this.grid.querySelectorAll('.product-grid__item'))
    }

    hasHidden() {
      return this.batch > 0 && this.items().some((item) => item.hidden)
    }

    handleClick() {
      if (this.hasHidden()) {
        this.revealNextBatch()
      } else {
        this.fetchNext()
      }
    }

    revealNextBatch() {
      const items = this.items()
      items.slice(this.shown, this.shown + this.batch).forEach((item) => {
        item.hidden = false
      })
      this.shown = Math.min(this.shown + this.batch, items.length)

      if (this.shown >= items.length && !this.btn.dataset.nextUrl) {
        this.remove()
      }
    }

    async fetchNext() {
      const url = this.btn.dataset.nextUrl
      if (!url) return

      this.btn.disabled = true
      this.btn.setAttribute('aria-busy', 'true')

      try {
        const res = await fetch(url)
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html')

        doc.querySelectorAll('.product-grid__item').forEach((item) => {
          if (this.batch > 0) item.hidden = true
          this.grid.appendChild(item)
        })

        const nextBtn = doc.querySelector('[data-load-more-btn]')
        if (nextBtn?.dataset.nextUrl) {
          this.btn.dataset.nextUrl = nextBtn.dataset.nextUrl
        } else {
          delete this.btn.dataset.nextUrl
        }
      } catch (err) {
        console.error('ia-load-more: fetch failed', err)
      } finally {
        this.btn.disabled = false
        this.btn.removeAttribute('aria-busy')
      }

      if (this.batch > 0) {
        this.revealNextBatch()
      } else if (!this.btn.dataset.nextUrl) {
        this.remove()
      }
    }
  }

  customElements.define('ia-load-more', IALoadMore)
}
